module.exports = __webpack_public_path__ + "img/icon-nuvemshop.b91a6d8b.svg";